import React from "react";
import Chart from "react-apexcharts";
import { LINE_CHART_OPTIONS } from "../../configurations/Constants";

function LineChart(props) {
  return (
    <Chart
      options={LINE_CHART_OPTIONS}
      series={props.series}
      type="line"
      width="100%"
      height={350}
    />
  );
}

export default LineChart;
